import {ApplicantState, ApplicantStateRestControllerApiFactory,} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip} from "../../../../components/kit";
import {TableCell} from "@mui/material";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {useApiManager} from "../../../../components/utils/api";

export const ApplicantStateListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<ApplicantState> = {
		title: "Listado de estados del proceso ",
		onClick: "/app/admin/recruitment/state",
		headers: [
			{title: "Nombre"},
			{title: "Final"}
		],
		decorator: (bean: ApplicantState) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.name}
				</TableCell>
				<TableCell>
					{bean.finalized ? <SoftChip tone="neutral" label="Cierra la candidatura"/> : ""}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(ApplicantStateRestControllerApiFactory);
			return ctrl.pageApplicantState(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};